import { useQuery, UseQueryResult } from 'react-query';
import { CompanyDocuments } from '../../models/CompanyDocuments';
import { SearchBondDto } from '../../services/dtos/securities/searchBonds.dto';
import { BondsSortOption } from '../../services/securities/securities.constants';
import { fetchBonds } from '../../services/securities/securities.service';
import { queryKeys } from '../queryKeyFactory';
import { SearchSecuritiesFilterValue } from './useFetchLoans';
import { fetchAllDocuments } from './utils/fetchAllDocuments';
import { groupDocuments } from './utils/groupDocuments';

export interface SearchBondsPayload {
  filters?: SearchSecuritiesFilterValue;
  sort?: BondsSortOption;
  sortDesc?: boolean;
  skip?: number;
  take?: number;
}

export default (
  companyId: string,
  payload: SearchBondsPayload,
  enabled = true
): UseQueryResult<CompanyDocuments<SearchBondDto>, Error> => {
  return useQuery<CompanyDocuments<SearchBondDto>, Error>(
    queryKeys.fetchBonds.allByIssuer(companyId, payload, enabled),
    async () => {
      const { totalResults, results } = await fetchAllDocuments<SearchBondDto, SearchBondsPayload>(fetchBonds, payload);
      const groupedBonds = groupDocuments(results);

      return { totalResults, results: groupedBonds };
    },
    { enabled: enabled && !Number.isNaN(Number(companyId)), retry: false }
  );
};
